import { useCallback, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useStore } from "../../hooks";
import { CouponCard } from "..";
import { StoreCouponModel } from "../../models";
import { isEmpty } from "../../helpers";

type Props = {
  show: boolean;
  handleClose: () => void;
  couponCode: string;
  validCoupon?: boolean;
  handleApplyCoupon: (code: string) => void;
};

const CartDiscount: React.FC<Props> = ({
  show,
  handleClose,
  couponCode: initialCode,
  validCoupon = false,
  handleApplyCoupon,
}) => {
  const [_, setCouponCode] = useState<string>(initialCode || "");
  const { storeCoupons } = useStore();

  const handleApply = useCallback(
    (code: string) => {
      setCouponCode(code);
      handleApplyCoupon(code);
    },
    [handleApplyCoupon],
  );

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      className="cart-offcanvas"
    >
      <div className="cart-offcanvas-inner">
        <Offcanvas.Header closeButton className="cart-sidebar-header">
          <Offcanvas.Title className="checkout-heading px-2 cart-sidebar-title">
            Apply Coupon
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="cart-sidebar-body common-cart-pd">
          {/* <div className="choose_payment_apply">
          {validCoupon ? (
            <Card>
              <CardBody className="d-flex flex-row justify-content-between align-items-center">
                <span className="d-flex flex-column">
                  <span className="text-muted fs-6 fw-bold">{couponCode}</span>
                  <span className="text-success d-flex flex-row align-items-center gap-1">
                    <Check2Circle /> 
                    <small>Applied Successfully</small>
                  </span>
                </span>
                <CloseButton onClick={() => handleApply("")} />
              </CardBody>
            </Card>
          ) : (
            <div className="choose_payment_apply_input pb-0 rounded">
              <input
                type="text"
                className="form-control text-uppercase"
                id="couponInput"
                placeholder="Enter your coupon code"
                value={couponCode}
                onInput={handleInputChange}
              />
              <button type="button" onClick={() => handleApplyCoupon(couponCode)}>APPLY</button>
            </div>
          )}
        </div> */}

          <div className="offer_reward_sec mt-3">
            {isEmpty(storeCoupons) && (
              <div className="text-center mb-5">No coupon code available</div>
            )}

            <ul>
              {storeCoupons
                .filter((item) => !item.is_auto)
                .map((coupon: StoreCouponModel) => (
                  <CouponCard
                    key={coupon.id}
                    coupon={coupon}
                    copy={false}
                    apply={!validCoupon}
                    handleApply={handleApply}
                  />
                ))}
            </ul>
          </div>
        </Offcanvas.Body>
      </div>
    </Offcanvas>
  );
};

export default CartDiscount;
